import { type Location as RouterLocation } from "react-router-dom";

import StorageManager from "@/features/storage";
import { AppRoute } from "@/types/routes";

interface NavigateOptions {
  state?: unknown;
  replace?: boolean;
}

export const openLink = (link: string, target = "_blank") => {
  window.open(link, target, "noopener,noreferrer");
};

const windowNavigate = (path: string, options: NavigateOptions = {}) => {
  const { state, replace } = options;

  if (replace) {
    window.history.replaceState(state, "", path);
  } else {
    window.history.pushState(state, "", path);
  }

  window.dispatchEvent(new PopStateEvent("popstate"));
};

export const navigateToLogin = (
  location: Pick<Location, "pathname" | "search" | "hash"> | RouterLocation,
  navigateOptions: NavigateOptions = {},
  navigateFn = windowNavigate
) => {
  StorageManager.removeToken();

  navigateFn(AppRoute.LOGIN, {
    state: { from: location },
    replace: true,
    ...navigateOptions,
  });
};

export const createSerializableLocation = (location: Location) => ({
  pathname: location.pathname,
  search: location.search,
  hash: location.hash,
});

export const getNextPageNumber = (
  pageMeta:
    | {
        total?: number;
        offset?: number;
        limit?: number;
      }
    | undefined
) => {
  if (!pageMeta) return undefined;

  const { total, offset, limit } = pageMeta;

  if (!total || !offset || !limit) return undefined;

  const currentItemsShown = offset * limit;

  if (currentItemsShown >= total) return undefined;

  return offset + 1;
};
